// NOTE: These are only needed for published pages right now

export const addA11yPropsToAnnotation = (annotationId: string) => {
	const annotationElement = document.getElementById(annotationId);

	if (annotationElement) {
		annotationElement.setAttribute('aria-haspopup', 'dialog');
	}
};

export const removeA11yPropsFromAnnotation = (annotationId: string) => {
	const annotationElement = document.getElementById(annotationId);

	if (annotationElement && annotationElement.hasAttribute('aria-haspopup')) {
		annotationElement.removeAttribute('aria-haspopup');
	}
};
